import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Form } from './Form'
import { Viewer } from './Viewer'

import clients from 'redux/clients'
const {
  cloudloyalty: { client }
} = clients

class VirtualVoucher extends Component {
  state = {
    email:
      (this.props.configuration && this.props.configuration.email) ||
      this.props.customer.email,
    isFormOpen: false,
    dirty: false,
    isLoading: false
  }

  handleEmail = event =>
    this.setState({ email: event.target.value, dirty: true })

  saveEmail = () => {
    this.setState({ isLoading: true })
    client
      .post(`v1/carts/1/me/emailAddress?email=${this.state.email}`)
      .then(_ => {
        this.setState({ isLoading: false, isFormOpen: false, dirty: false })
        this.props.formOpen(false)
        this.props.fetchCart()
      })
  }

  handleFormEdit = () => {
    this.setState({ isFormOpen: true })
    this.props.formOpen(true)
  }

  render () {
    const { email } = this.props.participant

    const { email: emailCustomer } = this.props.customer
    const emailToEdit = this.state.dirty ? this.state.email : emailCustomer

    if (this.state.isFormOpen) {
      return (
        <Fragment>
          <Viewer
            email={emailCustomer}
            isEditVisible={false}
            handleEdit={this.handleFormEdit}
          />
          <Form
            email={emailToEdit}
            handleEmail={this.handleEmail}
            saveEmail={this.saveEmail}
            isLoading={this.state.isLoading}
          />
        </Fragment>
      )
    }

    return (
      <Viewer
        email={emailCustomer}
        isEditVisible={email.disabled === 'false'}
        handleEdit={this.handleFormEdit}
      />
    )
  }
}

VirtualVoucher.propTypes = {
  participant: PropTypes.shape({
    email: PropTypes.object,
    isLoading: PropTypes.bool.isRequired
  }),
  configuration: PropTypes.shape({
    email: PropTypes.string.isRequired
  }),
  customer: PropTypes.shape({
    email: PropTypes.string.isRequired
  }),
  fetchCart: PropTypes.func.isRequired,
  formOpen: PropTypes.func
}

export default VirtualVoucher



// WEBPACK FOOTER //
// ./src/features/Cart/Summary/VirtualVoucher/VirtualVoucher.js